import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const UsageSurface = ({ onUsageSurfaceSelected }) => {
  const [selectedUsageSurface, setSelectedUsageSurface] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.usagesurface) {
        const usageSurfaceObject = firstResult.usagesurface;
        if (usageSurfaceObject.trim() !== "") {
          setVariations(usageSurfaceObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleUsageSurfaceClick = (usagesurface) => {
    setSelectedUsageSurface(usagesurface);
    onUsageSurfaceSelected(usagesurface);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Usage Surface:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedUsageSurface === variation ? "selected" : ""}`}
            onClick={() => handleUsageSurfaceClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default UsageSurface;
